/**
 * Turn a 0 - 1 float into a 0 - 100 percentage string without rounding.
 */
export const toPercentage = (x: number): string => `${Math.floor((x || 0) * 100)}%`;
